import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gem, Image as ImageIcon, Globe2, BadgeCheck, Award, Check, Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHead } from "./parts";

const ICON = { premium: Gem, image_host: ImageIcon, custom_domain: Globe2, verified: BadgeCheck, custom_badge: Award };

export default function Store() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/products").then(({ data }) => setItems(data)); }, []);
  const owned = (id) => (user.purchases || []).includes(id) || (id === "premium" && user.is_premium) || (id === "verified" && user.verified);
  const buy = async (id) => {
    setBusy(id);
    try { const { data } = await api.post("/payments/paypal/create", { product: id }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  return (
    <div>
      <PageHead eyebrow="store" title="lifetime upgrades" />
      <p className="-mt-6 mb-10 max-w-lg text-sm text-zinc-400">One-time payments, no subscriptions. Secure checkout with PayPal — perks unlock the moment payment is confirmed.</p>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((p, i) => {
          const I = ICON[p.id] || Gem;
          const has = owned(p.id);
          const hot = p.id === "premium";
          return (
            <div key={p.id} data-testid={`store-item-${p.id}`} style={{ animationDelay: `${i * 70}ms` }} className={`relative flex flex-col rounded-2xl border p-6 animate-fade-up transition-all duration-300 hover:-translate-y-1 ${hot ? "border-[#ff3b91]/50 bg-gradient-to-b from-[#ff3b91]/10 to-[#0d0d10] md:col-span-2 lg:col-span-1" : "border-[#1f1f28] bg-[#0d0d10] hover:border-[#ff3b91]/40"}`}>
              <div className="flex items-center justify-between">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#ff3b91]/10"><I className="h-5 w-5 text-[#ff3b91]" /></div>
                {hot && <span className="rounded-full bg-[#ff3b91] px-2.5 py-0.5 font-mono text-[10px] uppercase">best value</span>}
              </div>
              <div className="mt-5 font-display text-xl font-semibold">{p.name}</div>
              <p className="mt-2 flex-1 text-sm text-zinc-400">{p.desc}</p>
              <div className="mt-6 flex items-center justify-between">
                <span className="font-display text-3xl font-bold" data-testid={`store-price-${p.id}`}>€{p.price.toFixed(2)}</span>
                {has ? <span data-testid={`store-owned-${p.id}`} className="flex items-center gap-1.5 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-300"><Check className="h-4 w-4" />owned</span>
                  : <button onClick={() => buy(p.id)} disabled={!!busy || !user.email_verified} data-testid={`store-buy-${p.id}`} className={hot ? "btn-pink" : "btn-ghost"}>{busy === p.id ? <Loader2 className="h-4 w-4 animate-spin" /> : null}buy</button>}
              </div>
            </div>
          );
        })}
      </div>
      {!user.email_verified && <p className="mt-6 text-sm text-zinc-500" data-testid="store-verify-hint">Verify your email to make purchases.</p>}
    </div>
  );
}
